export default __webpack_public_path__ + "static/white-nr-gravel-bananatex-5d74d7d717f884fa840532775fa8fbbf.png";